import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { VocabularyArt2 } from './illustrations/vocabulary-art-2'
import { VocabularyArt5 } from './illustrations/vocabulary-art-5'
import { VocabularyArt1 } from './illustrations/vocabulary-art-1'
import { VocabularyArt4 } from './illustrations/vocabulary-art-4'
import { Cols, List, Title } from './styled'

export const Vocabulary = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <section ref={ref}>
    <Title data-menu-title="уникальные слова">
      <TextContainer>Уникальные для коми слова</TextContainer>
    </Title>

    <TextContainer position="relative">
      <p>Язык коми частично вдохновлен взаимоотношениями с окружающей средой. Они подбирали слова для описания определенных природных явлений, жизни животных, растений. </p>

      <VocabularyArt2 />

      <Cols>
        <VocabularyArt5 />
        <List>
          <div>
            <dt>Егыр</dt> <dd>заболоченный лес</dd>
          </div>
          <div>
            <dt>Сӧгра</dt>
            <dd>болотистое кочковатое место с корявым ельником</dd>
          </div>
          <div>
            <dt>Понӧль</dt> <dd>хвойная поросль</dd>
          </div>
          <div>
            <dt>Понӧляин</dt> <dd> место, поросшее хвойниками</dd>
          </div>
          <div>
            <dt>Яг</dt> <dd>сосновый бор</dd>
          </div>
          <div>
            <dt>Лос</dt> <dd>сырая низина</dd>
          </div>
          <div>
            <dt>Ноддя</dt>
            <dd>костер в пристанище, рассчитанный на долгое время</dd>
          </div>
          <div>
            <dt>Мылӧд</dt> <dd>болезненное слюновыделение</dd>
          </div>
          <div>
            <dt>Чорас</dt>
            <dd>замерзшая или засохшая комками грязь на дорогах</dd>
          </div>
        </List>
      </Cols>

      <Cols>
        <List>
          <div>
            <dt>Лежнӧгассьыны </dt>
            <dd> получить занозу, уколовшись шиповником</dd>
          </div>
          <div>
            <dt>Зэр-слöт</dt>
            <dd> снег с дождем</dd>
          </div>
          <div>
            <dt>Йöж </dt>
            <dd> когда что-то замерзло или оттаяло наполовину</dd>
          </div>
          <div>
            <dt>Кепйыны </dt>
            <dd> есть по ягодке</dd>
          </div>
          <div>
            <dt>Киль </dt>
            <dd> верхний шелушащийся слой бересты</dd>
          </div>
          <div>
            <dt>Ӧщӧпек </dt>
            <dd> остаток полена, колотого на лучину</dd>
          </div>
          <div>
            <dt>Идас </dt>
            <dd>корм для белок</dd>
          </div>
          <div>
            <dt>Содзтыр </dt>
            <dd>
              количество воды, которое умещается в ладонях (например, при
              умывании)
            </dd>
          </div>
        </List>
        <VocabularyArt1 />
      </Cols>
      <VocabularyArt4 />
    </TextContainer>
  </section>
))
